module.exports = __webpack_public_path__ + "static/media/box-up.a472ecbc.svg";